import { gql } from "@apollo/client";

export const SOCCER_LEADERS = gql`
    query SoccerLeaders($seasonId: ID!, $stageId: ID, $limit: Int) {
        soccerLeaders(seasonId: $seasonId, stageId: $stageId, limit: $limit) {
            topScorers {
                value
                player { id fullName logoUrl }
                team { id name logoUrl }
            }
            topAssists {
                value
                player { id fullName logoUrl }
                team { id name logoUrl }
            }
            topRedCards {
                value
                player { id fullName logoUrl }
                team { id name logoUrl }
            }
            topGoalContributions {
                value
                player { id fullName logoUrl }
                team { id name logoUrl }
            }
            topOwnGoals {
                value
                player { id fullName logoUrl }
                team { id name logoUrl }
            }
        }
    }
`;


export const SOCCER_ACCUMULATED_YELLOW_CARDS = gql`
  query AccumulatedYellowCards($seasonId: Int!, $stageId: Int, $page: Int, $pageSize: Int) {
    accumulatedYellowCards(seasonId: $seasonId, stageId: $stageId, page: $page, pageSize: $pageSize) {
      page
      pages
      objects {
        id
        yellowCards
        player { id fullName logoUrl }
        team { id name logoUrl }
      }
    }
  }
`;

export const SOCCER_MOST_GAMES_PLAYED = gql`
    query SoccerMostGamesPlayed(
        $seasonId: Int!
        $stageId: Int
        $page: Int
        $pageSize: Int
    ) {
        mostGamesPlayed(
            seasonId: $seasonId
            stageId: $stageId
            page: $page
            pageSize: $pageSize
        ) {
            page
            pages
            hasNext
            hasPrev
            objects {
                profileId
                gamesPlayed
                player {
                    id
                    fullName
                    logoUrl
                }
                team {
                    id
                    name
                    logoUrl
                }
            }
        }
    }
`
